import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardMedia,
  Box,
  Grid,
  IconButton,
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DashboardVehicle from "../../../assets/DashboardVehicle.png";
import { useGetVehicleManagementSearchDashboardQuery } from "../../../Api/apiSlice";
import VehicleCard from "./VehicleCard";

// Dummy API Data (Replace with actual backend response)
const vehicleData = [
  {
    name: "Ford Transit 350",
    model: "2021",
    year: "2021",
    engine: "3.5L V6 EcoBoost",
    isAssigned: true,
    image: DashboardVehicle, // Replace with actual image path
  },
  {
    name: "Chevrolet Express 2500",
    model: "2020",
    year: "2020",
    engine: "4.3L V6",
    isAssigned: true,
    image: DashboardVehicle, // Replace with actual image path
  },
  {
    name: "Mercedes-Benz Sprinter",
    model: "2022",
    year: "2022",
    engine: "2.0L 4-Cylinder Turbo Diesel",
    isAssigned: true,
    image: DashboardVehicle, // Replace with actual image path
  },
];

function DashboardVehicleCard() {
  const search = "";
  const status = "";

  // Fetch vehicle data
  const {
    data: vehicleDataResponse,
    isLoading: isVehiclesLoading,
    error: vehicleError,
  } = useGetVehicleManagementSearchDashboardQuery({ search, status });
console.log("Icle Data",vehicleDataResponse);
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentVehicle = vehicleData[currentIndex];
  const data = vehicleData?.isAssigned ? vehicleData : null;

  // Handlers for Next and Prev buttons
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % vehicleData.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + vehicleData.length) % vehicleData.length
    );
  };

  return (
    <div>
    {isVehiclesLoading ? (
      <p>Loading vehicles...</p>
    ) : vehicleError ? (
      <p>Error loading vehicles</p>
    ) : (
      <VehicleCard vehicleData={vehicleDataResponse} />
    )}
  </div>
  );
}

export default DashboardVehicleCard;
